@if (current) {
  <ds-bill-account-register
    [pendingRegistration]="current"
    [isMyAccount]="true"
    [index]="index"
    [count]="pendingRegistrations.length"
    [acceptTerms]="acceptTerms"
    (registrationSuccessEvent)="onRegistrationSuccess($event)"
    (registrationErrorEvent)="onRegistrationError($event)"
  >
  </ds-bill-account-register>
}
